module.exports = "/images/icon-zip.svg?8e18b6b7e5dcb1f577d83d94177a1a9c";